import styled from "styled-components";

export default styled.h3`
  max-width: 650px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 24px;
  margin-bottom: 12px;
`
